<template>
  <div class="purchase unlock-subscribe">
    <SubscribeHeader :noCloseBtn="noCloseBtn" @onClose="$emit('onClose')" />
    <div class="purchase__body">
      <div class="purchase__app">
        <svg
          width="18"
          height="23"
          viewBox="0 0 18 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_686_4007)">
            <path
              d="M14.8204 12.7917C14.8273 11.9562 15.0477 11.1362 15.4608 10.4099C15.8739 9.68351 16.4658 9.07485 17.1804 8.64173C16.725 7.99798 16.1271 7.46812 15.4333 7.09345C14.7394 6.71878 13.9684 6.50943 13.1804 6.48172C11.4804 6.31172 9.87041 7.48172 9.01042 7.48172C8.15042 7.48172 6.82041 6.48173 5.41041 6.53173C4.48649 6.55669 3.58494 6.82147 2.79426 7.30008C2.00358 7.7787 1.35092 8.4547 0.900399 9.26172C-1.0196 12.6017 0.410404 17.5417 2.2804 20.2617C3.2004 21.5917 4.28041 23.0717 5.72041 23.0217C7.16041 22.9717 7.63041 22.1317 9.29041 22.1317C10.9504 22.1317 11.4304 23.0217 12.8904 22.9917C14.3504 22.9617 15.3204 21.6417 16.2304 20.3217C16.8753 19.3636 17.3835 18.3202 17.7404 17.2217C16.8744 16.8489 16.1365 16.2308 15.6177 15.4436C15.0988 14.6564 14.8216 13.7345 14.8204 12.7917Z"
              fill="white"
            />
            <path
              d="M12.2602 3.67C13.1269 2.65237 13.5548 1.33261 13.4502 0C12.1407 0.130171 10.9293 0.751962 10.0601 1.74001C9.63033 2.2225 9.30105 2.78586 9.09157 3.39713C8.88209 4.0084 8.79662 4.6553 8.84014 5.3C9.49682 5.30751 10.1465 5.16451 10.7393 4.88196C11.3322 4.59941 11.8524 4.18482 12.2602 3.67Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_686_4007">
              <rect width="17.75" height="23" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <svg
          width="22"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_686_4010)">
            <path
              d="M2.37002 20.6612L13.37 10.3012L2.26002 0.0211532C1.97413 -0.0207602 1.68255 -0.000228934 1.40536 0.0813339C1.12816 0.162897 0.871937 0.303556 0.654306 0.493626C0.436675 0.683697 0.262804 0.91865 0.144678 1.18235C0.026551 1.44604 -0.0330305 1.73222 -0.0299744 2.02115V18.7212C-0.0351083 19.0181 0.0259247 19.3124 0.148706 19.5827C0.271487 19.8531 0.452933 20.0927 0.679864 20.2842C0.906796 20.4757 1.17353 20.6143 1.46069 20.6899C1.74784 20.7654 2.04822 20.7761 2.34002 20.7212L2.37002 20.6612Z"
              fill="white"
            />
            <path
              d="M17.0696 6.85875L5.05957 1.21875L14.1296 9.61875L17.0696 6.85875Z"
              fill="white"
            />
            <path
              d="M14.1404 10.9883L5.15039 19.4283L17.1604 13.7883L14.1404 10.9883Z"
              fill="white"
            />
            <path
              d="M20.6401 8.52863L18.0501 7.30859L14.8701 10.3086L18.1401 13.3086L20.6401 12.1386C20.9837 11.9771 21.2742 11.7212 21.4777 11.4006C21.6812 11.0801 21.7893 10.7083 21.7893 10.3286C21.7893 9.94895 21.6812 9.57717 21.4777 9.25665C21.2742 8.93614 20.9837 8.68013 20.6401 8.51862V8.52863Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_686_4010">
              <rect width="21.79" height="20.7" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="purchase__rating">
        <svg
          width="112"
          height="16"
          viewBox="0 0 112 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_686_4004)">
            <path
              d="M15.9996 5.55957C15.9783 5.49335 15.9364 5.43571 15.8801 5.39494C15.8237 5.35417 15.7559 5.33243 15.6863 5.33293H10.253L8.33295 0.219564C8.30959 0.155214 8.26702 0.0996751 8.21096 0.0603841C8.1549 0.0210932 8.08809 0 8.01963 0C7.95118 0 7.88437 0.0210932 7.82831 0.0603841C7.77225 0.0996751 7.72968 0.155214 7.70632 0.219564L5.78632 5.33293H0.352967C0.283411 5.33243 0.215477 5.35417 0.159119 5.39494C0.102762 5.43571 0.0609445 5.49335 0.0396532 5.55957C0.0156645 5.62403 0.0130344 5.69453 0.0322476 5.76058C0.0514608 5.82662 0.0914359 5.88473 0.146261 5.92627L4.62624 9.7863L2.70632 15.5596C2.68596 15.6256 2.68663 15.6965 2.70827 15.7621C2.72992 15.8278 2.77143 15.8851 2.82709 15.9261C2.88275 15.9671 2.94977 15.9898 3.0189 15.991C3.08803 15.9923 3.15583 15.972 3.21291 15.9329L8.01963 12.4129L12.8263 15.9329C12.8834 15.972 12.9512 15.9923 13.0203 15.991C13.0894 15.9898 13.1564 15.9671 13.2121 15.9261C13.2678 15.8851 13.3093 15.8278 13.331 15.7621C13.3526 15.6965 13.3533 15.6256 13.3329 15.5596L11.4129 9.7863L15.8929 5.92627C15.9478 5.88473 15.9877 5.82662 16.0069 5.76058C16.0262 5.69453 16.0236 5.62403 15.9996 5.55957Z"
              fill="white"
            />
          </g>
          <g clip-path="url(#clip1_686_4004)">
            <path
              d="M39.9996 5.55957C39.9783 5.49335 39.9364 5.43571 39.8801 5.39494C39.8237 5.35417 39.7559 5.33243 39.6863 5.33293H34.253L32.3329 0.219564C32.3096 0.155214 32.267 0.0996751 32.211 0.0603841C32.1549 0.0210932 32.0881 0 32.0196 0C31.9512 0 31.8844 0.0210932 31.8283 0.0603841C31.7722 0.0996751 31.7297 0.155214 31.7063 0.219564L29.7863 5.33293H24.353C24.2834 5.33243 24.2155 5.35417 24.1591 5.39494C24.1028 5.43571 24.0609 5.49335 24.0397 5.55957C24.0157 5.62403 24.013 5.69453 24.0322 5.76058C24.0515 5.82662 24.0914 5.88473 24.1463 5.92627L28.6262 9.7863L26.7063 15.5596C26.686 15.6256 26.6866 15.6965 26.7083 15.7621C26.7299 15.8278 26.7714 15.8851 26.8271 15.9261C26.8828 15.9671 26.9498 15.9898 27.0189 15.991C27.088 15.9923 27.1558 15.972 27.2129 15.9329L32.0196 12.4129L36.8263 15.9329C36.8834 15.972 36.9512 15.9923 37.0203 15.991C37.0894 15.9898 37.1564 15.9671 37.2121 15.9261C37.2678 15.8851 37.3093 15.8278 37.331 15.7621C37.3526 15.6965 37.3533 15.6256 37.3329 15.5596L35.4129 9.7863L39.8929 5.92627C39.9478 5.88473 39.9877 5.82662 40.0069 5.76058C40.0262 5.69453 40.0236 5.62403 39.9996 5.55957Z"
              fill="white"
            />
          </g>
          <g clip-path="url(#clip2_686_4004)">
            <path
              d="M63.9996 5.55957C63.9783 5.49335 63.9364 5.43571 63.8801 5.39494C63.8237 5.35417 63.7559 5.33243 63.6863 5.33293H58.253L56.3329 0.219564C56.3096 0.155214 56.267 0.0996751 56.211 0.0603841C56.1549 0.0210932 56.0881 0 56.0196 0C55.9512 0 55.8844 0.0210932 55.8283 0.0603841C55.7722 0.0996751 55.7297 0.155214 55.7063 0.219564L53.7863 5.33293H48.353C48.2834 5.33243 48.2155 5.35417 48.1591 5.39494C48.1028 5.43571 48.0609 5.49335 48.0397 5.55957C48.0157 5.62403 48.013 5.69453 48.0322 5.76058C48.0515 5.82662 48.0914 5.88473 48.1463 5.92627L52.6262 9.7863L50.7063 15.5596C50.686 15.6256 50.6866 15.6965 50.7083 15.7621C50.7299 15.8278 50.7714 15.8851 50.8271 15.9261C50.8828 15.9671 50.9498 15.9898 51.0189 15.991C51.088 15.9923 51.1558 15.972 51.2129 15.9329L56.0196 12.4129L60.8263 15.9329C60.8834 15.972 60.9512 15.9923 61.0203 15.991C61.0894 15.9898 61.1564 15.9671 61.2121 15.9261C61.2678 15.8851 61.3093 15.8278 61.331 15.7621C61.3526 15.6965 61.3533 15.6256 61.3329 15.5596L59.4129 9.7863L63.8929 5.92627C63.9478 5.88473 63.9877 5.82662 64.0069 5.76058C64.0262 5.69453 64.0236 5.62403 63.9996 5.55957Z"
              fill="white"
            />
          </g>
          <g clip-path="url(#clip3_686_4004)">
            <path
              d="M87.9996 5.55957C87.9783 5.49335 87.9364 5.43571 87.8801 5.39494C87.8237 5.35417 87.7559 5.33243 87.6863 5.33293H82.253L80.3329 0.219564C80.3096 0.155214 80.267 0.0996751 80.211 0.0603841C80.1549 0.0210932 80.0881 0 80.0196 0C79.9512 0 79.8844 0.0210932 79.8283 0.0603841C79.7722 0.0996751 79.7297 0.155214 79.7063 0.219564L77.7863 5.33293H72.353C72.2834 5.33243 72.2155 5.35417 72.1591 5.39494C72.1028 5.43571 72.0609 5.49335 72.0397 5.55957C72.0157 5.62403 72.013 5.69453 72.0322 5.76058C72.0515 5.82662 72.0914 5.88473 72.1463 5.92627L76.6262 9.7863L74.7063 15.5596C74.686 15.6256 74.6866 15.6965 74.7083 15.7621C74.7299 15.8278 74.7714 15.8851 74.8271 15.9261C74.8828 15.9671 74.9498 15.9898 75.0189 15.991C75.088 15.9923 75.1558 15.972 75.2129 15.9329L80.0196 12.4129L84.8263 15.9329C84.8834 15.972 84.9512 15.9923 85.0203 15.991C85.0894 15.9898 85.1564 15.9671 85.2121 15.9261C85.2678 15.8851 85.3093 15.8278 85.331 15.7621C85.3526 15.6965 85.3533 15.6256 85.3329 15.5596L83.4129 9.7863L87.8929 5.92627C87.9478 5.88473 87.9877 5.82662 88.0069 5.76058C88.0262 5.69453 88.0236 5.62403 87.9996 5.55957Z"
              fill="white"
            />
          </g>
          <g clip-path="url(#clip4_686_4004)">
            <path
              d="M112 5.55957C111.978 5.49335 111.936 5.43571 111.88 5.39494C111.824 5.35417 111.756 5.33243 111.686 5.33293H106.253L104.333 0.219564C104.31 0.155214 104.267 0.0996751 104.211 0.0603841C104.155 0.0210932 104.088 0 104.02 0C103.951 0 103.884 0.0210932 103.828 0.0603841C103.772 0.0996751 103.73 0.155214 103.706 0.219564L101.786 5.33293H96.353C96.2834 5.33243 96.2155 5.35417 96.1591 5.39494C96.1028 5.43571 96.0609 5.49335 96.0397 5.55957C96.0157 5.62403 96.013 5.69453 96.0322 5.76058C96.0515 5.82662 96.0914 5.88473 96.1463 5.92627L100.626 9.7863L98.7063 15.5596C98.686 15.6256 98.6866 15.6965 98.7083 15.7621C98.7299 15.8278 98.7714 15.8851 98.8271 15.9261C98.8828 15.9671 98.9498 15.9898 99.0189 15.991C99.088 15.9923 99.1558 15.972 99.2129 15.9329L104.02 12.4129L108.826 15.9329C108.883 15.972 108.951 15.9923 109.02 15.991C109.089 15.9898 109.156 15.9671 109.212 15.9261C109.268 15.8851 109.309 15.8278 109.331 15.7621C109.353 15.6965 109.353 15.6256 109.333 15.5596L107.413 9.7863L111.893 5.92627C111.948 5.88473 111.988 5.82662 112.007 5.76058C112.026 5.69453 112.024 5.62403 112 5.55957Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_686_4004">
              <rect width="16" height="16" fill="white" />
            </clipPath>
            <clipPath id="clip1_686_4004">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(24)"
              />
            </clipPath>
            <clipPath id="clip2_686_4004">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(48)"
              />
            </clipPath>
            <clipPath id="clip3_686_4004">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(72)"
              />
            </clipPath>
            <clipPath id="clip4_686_4004">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(96)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <h3 class="purchase__title">{{ packageTitles[currentPackage] }}</h3>
      <ul class="unlock-subscribe__list purchase__list">
        <li
          class="unlock-subscribe__item purchase__item"
          v-for="(item, i) in items"
          :key="i"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 9L10 16L7.5 13.5"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span>{{ item }}</span>
        </li>
      </ul>
      <div v-if="isPackageLoading" class="skeleton-loader">
        <a-skeleton-button
          style="width: 327px; height: 92px; margin-top: 32px"
          active
          block
          shape="round"
        />
        <a-skeleton-button
          style="height: 327px; height: 153px; margin-top: 20px"
          block
          active
          shape="round"
        />
        <a-skeleton-button
          style="
            width: 327px;
            height: 92px;
            margin-top: 20px;
            margin-bottom: 32px;
          "
          active
          block
          shape="round"
        />
      </div>
      <!-- <a-radio-group v-show="!isPackageLoading" v-model:value="currentPackage">
        <div class="package__items">
          <template v-for="c in defaultPackages" :key="c.id">
            <payment-lifetime-card
              v-if="c.is_lifetime"
              :data="c"
              :popular="c.tags === packagePopular"
            />
            <payment-monthly-card
              v-else-if="c.months === 1"
              :data="c"
              :popular="c.tags === packagePopular"
            />
            <payment-yearly-card
              v-else
              :data="c"
              :popular="c.tags === packagePopular"
            />
          </template>
      
        </div>
      </a-radio-group> -->
      <PackagesCards
        :isPackageLoading="isPackageLoading"
        :onGetPlan="onGetPlan"
        :defaultPackages="defaultPackages"
        v-model="currentPackage"
        removeContainer
        fullWithButton
      />
      <!-- <button
        class="package__submit"
        :disabled="isPackageLoading"
        @click="onGetPlan"
      >
        Get My Plan
      </button> -->
      <template v-if="isYearlyPackage">
        <p class="purchase__cancel-info">
          You may cancel at any time in your trial. {{ getYearly.amount }}
          {{ getYearly.currency }}
          billed annually after trial. To cancel your subscription, email us at
          help@mentalfuture.com
        </p>
      </template>
      <template v-if="isMonthlyPackage">
        <p class="purchase__cancel-info">
          To cancel your subscription, email us at help@mentalfuture.com
        </p>
      </template>
      <div
        class="purchase__trial-work p-card extra-space"
        v-if="isYearlyPackage"
      >
        <p class="purchase__trial-work__title normal">How your trial works</p>
        <div class="purchase__trial-work__body">
          <div class="purchase__trial-work__icons">
            <svg
              width="18"
              height="24"
              viewBox="0 0 18 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18C10.1046 18 11 17.1046 11 16C11 14.8954 10.1046 14 9 14C7.89543 14 7 14.8954 7 16C7 17.1046 7.89543 18 9 18Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.5 9.5H4.5C2.29086 9.5 0.5 11.2909 0.5 13.5V19.5C0.5 21.7091 2.29086 23.5 4.5 23.5H13.5C15.7091 23.5 17.5 21.7091 17.5 19.5V13.5C17.5 11.2909 15.7091 9.5 13.5 9.5Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.5 6C3.5 4.54131 4.07951 3.14241 5.11096 2.11096C6.14241 1.07951 7.54131 0.5 9 0.5C10.4587 0.5 11.8576 1.07951 12.889 2.11096C13.9205 3.14241 14.5 4.54131 14.5 6V9.63"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              width="24"
              height="21"
              viewBox="0 0 24 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.23 4.55859L17.14 8.90859L14.21 6.07859"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.5 12.5C20.8137 12.5 23.5 9.81371 23.5 6.5C23.5 3.18629 20.8137 0.5 17.5 0.5C14.1863 0.5 11.5 3.18629 11.5 6.5C11.5 9.81371 14.1863 12.5 17.5 12.5Z"
                stroke="white"
                stroke-linejoin="round"
              />
              <path
                d="M9 3.5C8.33696 3.5 7.70108 3.76334 7.23224 4.23218C6.7634 4.70102 6.5 5.33696 6.5 6C5.31545 6.49356 4.3035 7.32667 3.59167 8.39441C2.87985 9.46215 2.5 10.7167 2.5 12V16.5C2.5 17.0304 2.28929 17.5391 1.91422 17.9142C1.53914 18.2893 1.03043 18.5 0.5 18.5H17.5C16.9696 18.5 16.4609 18.2893 16.0858 17.9142C15.7107 17.5391 15.5 17.0304 15.5 16.5V14.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11 18.5C11 19.0304 10.7893 19.5391 10.4142 19.9142C10.0391 20.2893 9.53043 20.5 9 20.5C8.46957 20.5 7.96086 20.2893 7.58578 19.9142C7.21071 19.5391 7 19.0304 7 18.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              width="24"
              height="19"
              viewBox="0 0 24 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 18.5H5.5C4.17392 18.5 2.90216 17.9732 1.96448 17.0355C1.0268 16.0978 0.5 14.8261 0.5 13.5V10.17C0.5 4.50004 4.5 3.5 6.5 3.5H9.5C10.5 3.5 11.5 4 11.5 5V5.5C11.5 6.5 10.5 7 9.5 7H7.5C7.5 7 6.5 10.5 4.5 10.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.5 12.5H17C17.3978 12.5 17.7794 12.658 18.0607 12.9393C18.342 13.2206 18.5 13.6022 18.5 14C18.5 14.3978 18.342 14.7794 18.0607 15.0607C17.7794 15.342 17.3978 15.5 17 15.5H13"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.5 15.5H13C13.3978 15.5 13.7794 15.658 14.0607 15.9393C14.342 16.2206 14.5 16.6022 14.5 17C14.5 17.3978 14.342 17.7794 14.0607 18.0607C13.7794 18.342 13.3978 18.5 13 18.5H11.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M23.5004 4.5H11.4004"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.5 3.57996V2C5.5 1.60218 5.65803 1.22064 5.93933 0.939331C6.22064 0.658026 6.60218 0.5 7 0.5H22C22.3978 0.5 22.7794 0.658026 23.0607 0.939331C23.342 1.22064 23.5 1.60218 23.5 2V11C23.5 11.3978 23.342 11.7794 23.0607 12.0607C22.7794 12.342 22.3978 12.5 22 12.5H7C6.60218 12.5 6.22064 12.342 5.93933 12.0607C5.65803 11.7794 5.5 11.3978 5.5 11V10.1899"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.5 6.5H18.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="purchase__trial-work__items">
            <div class="purchase__trial-work__item">
              <p class="purchase__trial-work__item--title">Today</p>
              <p class="purchase__trial-work__item--text">
                Start your full access to all premium content
              </p>
            </div>
            <div class="purchase__trial-work__item">
              <p class="purchase__trial-work__item--title">Day 5</p>
              <p class="purchase__trial-work__item--text">
                Get a reminder about when your trial will end
              </p>
            </div>
            <div class="purchase__trial-work__item">
              <p class="purchase__trial-work__item--title">Day 7</p>
              <p class="purchase__trial-work__item--text">
                You’ll be charged today, cancel anytime before
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="purchase__guarantee p-card mb-48">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5Z"
            stroke="white"
            stroke-linejoin="round"
          />
          <path
            d="M12 17.9981C12 17.9981 17.5 13.9981 17.5 10.9981C17.5 7.57807 13 6.4981 12 10.6581C11 6.4981 6.5 7.57807 6.5 10.9981C6.5 13.9981 12 17.9981 12 17.9981Z"
            stroke="white"
            stroke-linejoin="round"
          />
        </svg>
        <p class="purchase__guarantee__text">
          Your purchase supports our experts & helps us offer Mental Future for
          free to those in need
        </p>
      </div>

      <p class="purchase__p purchase__p-m">Similar people</p>

      <div class="purchase__svg-wrapper">
        <svg width="70" height="43" viewBox="0 0 70 43" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.307 22.509a7.692 7.692 0 100-15.384 7.692 7.692 0 000 15.384z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.168 34.816H1a12.308 12.308 0 0122.245-7.292M56.381 22.509a7.692 7.692 0 100-15.384 7.692 7.692 0 000 15.384z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M46.443 27.555a12.306 12.306 0 0119.9.033 12.308 12.308 0 012.345 7.228H51.52M45.95 12.107a11.105 11.105 0 01-13.274 10.894A11.108 11.108 0 0134.843 1 11.107 11.107 0 0145.95 12.107z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M52.628 41.002H17.06a17.784 17.784 0 0135.568 0z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>

      <p class="purchase__p purchase__p-l">3 out of 4</p>

      <p class="purchase__p purchase__p-s purchase__feel-better">
        Started To Feel Better
      </p>

      <p class="purchase__p purchase__p-xs">With Only 2 Weeks In The Program</p>
    </div>
    <div class="purchase__comments">
      <div
        class="purchase__comment"
        :class="{ middle: comment.id === 2 }"
        v-for="comment in purchaseComments"
        :key="comment.id"
      >
        <p class="purchase__comment__text">
          {{ comment.comment }}
        </p>
        <div class="purchase__comment__author">
          <img :src="comment.image" />
          <div class="purchase__comment__author-right">
            <p class="purchase__comment__author-name">{{ comment.name }}</p>
            <svg width="112" height="16" viewBox="0 0 112 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_7463_2693)"><path d="M16 5.56a.327.327 0 00-.314-.227h-5.433L8.333.22a.333.333 0 00-.627 0l-1.92 5.113H.353a.327.327 0 00-.313.227.32.32 0 00.106.366l4.48 3.86-1.92 5.774a.333.333 0 00.507.373l4.807-3.52 4.806 3.52a.332.332 0 00.507-.373l-1.92-5.774 4.48-3.86A.32.32 0 0016 5.56z" fill="#fff"/></g><g clip-path="url(#clip1_7463_2693)"><path d="M40 5.56a.327.327 0 00-.314-.227h-5.433L32.333.22a.333.333 0 00-.627 0l-1.92 5.113h-5.433a.327.327 0 00-.313.227.32.32 0 00.106.366l4.48 3.86-1.92 5.774a.333.333 0 00.507.373l4.807-3.52 4.806 3.52a.332.332 0 00.507-.373l-1.92-5.774 4.48-3.86A.32.32 0 0040 5.56z" fill="#fff"/></g><g clip-path="url(#clip2_7463_2693)"><path d="M64 5.56a.327.327 0 00-.314-.227h-5.433L56.333.22a.333.333 0 00-.627 0l-1.92 5.113h-5.433a.327.327 0 00-.313.227.32.32 0 00.106.366l4.48 3.86-1.92 5.774a.333.333 0 00.507.373l4.807-3.52 4.806 3.52a.332.332 0 00.507-.373l-1.92-5.774 4.48-3.86A.32.32 0 0064 5.56z" fill="#fff"/></g><g clip-path="url(#clip3_7463_2693)"><path d="M88 5.56a.327.327 0 00-.314-.227h-5.433L80.333.22a.333.333 0 00-.627 0l-1.92 5.113h-5.433a.327.327 0 00-.313.227.32.32 0 00.106.366l4.48 3.86-1.92 5.774a.333.333 0 00.507.373l4.807-3.52 4.806 3.52a.332.332 0 00.507-.373l-1.92-5.774 4.48-3.86A.32.32 0 0088 5.56z" fill="#fff"/></g><g clip-path="url(#clip4_7463_2693)"><path d="M112 5.56a.325.325 0 00-.314-.227h-5.433L104.333.22a.331.331 0 00-.313-.22.334.334 0 00-.314.22l-1.92 5.113h-5.433a.327.327 0 00-.313.227.32.32 0 00.106.366l4.48 3.86-1.92 5.774a.333.333 0 00.507.373l4.807-3.52 4.806 3.52a.332.332 0 00.505-.17.333.333 0 00.002-.203l-1.92-5.774 4.48-3.86A.318.318 0 00112 5.56z" fill="#fff"/></g><defs><clipPath id="clip0_7463_2693"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip1_7463_2693"><path fill="#fff" transform="translate(24)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip2_7463_2693"><path fill="#fff" transform="translate(48)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip3_7463_2693"><path fill="#fff" transform="translate(72)" d="M0 0h16v16H0z"/></clipPath><clipPath id="clip4_7463_2693"><path fill="#fff" transform="translate(96)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
          </div>
        </div>
      </div>
    </div>
    <p class="purchase__cancel-info purchase__note" v-if="isYearlyPackage">
      PLEASE NOTE: After your 7-days introductory offer, unless you cancel
      online in your profile before the end of then-current period, your plan
      will automatically convert to our yearly subscription plan at a
      non-discounted price and you will be charged {{ getYearly.amount }}
      {{ getYearly.currency }} each year before you cancel. Subscriptions renew
      automatically at the end of each period unless you cancel online in your
      profile. If you are unsure how to cancel, visit our Subscription Terms.
      Prepayment of total plan cost required. You will need an Android or iOS
      mobile phone to access the full version of the product. You may want to
      take a screenshot of this information and save it.
    </p>
    <p v-if="isMonthlyPackage" class="purchase__cancel-info purchase__note">
      PLEASE NOTE: Subscriptions renew automatically at the end of each period
      unless you cancel online in your profile. If you are unsure how to cancel,
      visit our Subscription Terms. Prepayment of total plan cost required. You
      will need an Android or iOS mobile phone to access the full version of the
      product. You may want to take a screenshot of this information and save
      it.
    </p>
    <div class="purchase__wrapper">
      <button class="paywall-button full-width" @click="onGetPlan">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="26" viewBox="0 0 30 26" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.2 25a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM10 25a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM1 1h4.2L10 21.4h13.2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.437 19H25l3.6-10.8H6.892" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Get My Plan
      </button>
    </div>
  </div>
  <PaymentsModal
    :isOpen="isOpen"
    :isEurope="isEurope"
    @close="isOpen = false"
    :currentPackage="currentPackage"
    @onSuccess="onSuccess"
  />
</template>

<script>
import SubscribeHeader from './SubscribeHeader.vue'
import PaymentsModal from '@/components/subscribe/PaymentsModal.vue'
import {
  purchaseTypes,
  purchaseComments,
  paymentTypes,
  packagePopular,
  metaEventCustomActions,
  packagePlaces,
} from '@/data/constants'
import { mapActions, mapState } from 'vuex'
import PaymentMonthlyCard from './PaymentMonthlyCard.vue'
import PaymentYearlyCard from './PaymentYearlyCard.vue'
import PaymentLifetimeCard from './PaymentLifetimeCard.vue'
import { loadFacebookPixel, initFacebook } from '@/utils/facebookConfig'
import { getCountryByIp } from '@/services/other.service'
import { currency } from '@/data/constants'
import { checkoutTypes } from '../../data/constants'
import PackagesCards from './PackagesCards.vue'

const packageTitles = {
  [purchaseTypes.MONTHLY]: 'Start Your Monthly Plan',
  [purchaseTypes.YEARLY]: 'Start Your 7-Day Trial',
  [purchaseTypes.LIFETIME]: 'Get Your Lifetime Plan',
}

export default {
  name: 'Purchase',
  components: {
    SubscribeHeader,
    PaymentsModal,
    PaymentMonthlyCard,
    PaymentYearlyCard,
    PaymentLifetimeCard,
    PackagesCards,
  },
  props: {
    noCloseBtn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSuccess', 'onClose'],
  data() {
    return {
      purchaseComments,
      purchaseTypes,
      items: [
        'Find inner peace, reduce stress and anxiety and fall asleep easily',
        'Access a rich library of meditations, sleepcasts and music created by top experts',
        'Gain control of your thoughts with Cognitive Behavioural Therapy (CBT)',
      ],
      currentPackage: '',
      isOpen: false,
      packageTitles,
      paymentTypes,
      packagePopular,
      isEurope: false,
    }
  },
  computed: {
    ...mapState('packageModule', ['packages', 'isPackageLoading']),
    ...mapState('subscription', ['action']),
    ...mapState('checkout', ['checkoutType']),
    ...mapState(['token']),
    getYearly() {
      return (
        (this.packages && this.getPackageByCondition((i) => i.months === 12)) ||
        {}
      )
    },
    isYearlyPackage() {
      return this.currentPackage === this.purchaseTypes.YEARLY
    },
    isMonthlyPackage() {
      return this.currentPackage === this.purchaseTypes.MONTHLY
    },
    defaultPackages() {
      if (this.packages.some((i) => i.currency === currency.EUR)) {
        return this.isEurope
          ? this.packages.filter(
              (i) =>
                i.provider === this.paymentTypes.STRIPE &&
                i.currency === currency.EUR
            )
          : this.packages.filter(
              (i) =>
                i.provider === this.paymentTypes.STRIPE &&
                i.currency === currency.USD
            )
      }
      return this.packages.filter(
        (i) => i.provider === this.paymentTypes.STRIPE
      )
    },
  },
  watch: {
    defaultPackages: {
      immediate: true,
      handler() {
        // if (this.currentPackage) return
        // const freeTrial = this.defaultPackages.find((i) => i.is_free_trial)
        // if (freeTrial) {
        //   this.currentPackage = this.getPackageValue(freeTrial)
        // } else {
        //   if (this.defaultPackages.length) {
        //     this.currentPackage = this.getPackageValue(this.defaultPackages[0])
        //   }
        // }
        if (this.currentPackage) return
        const isBestValue = this.defaultPackages.find(
          (i) => i.tags == 'Best Value' || i.tags == 'Most Popular'
        )
        if (isBestValue) {
          this.currentPackage = this.getPackageValue(isBestValue)
        } else {
          if (this.defaultPackages.length) {
            this.currentPackage = this.getPackageValue(this.defaultPackages[0])
          }
        }
      },
    },
  },
  created() {
    getCountryByIp()
      .then((res) => {
        this.isEurope = res.timezone.split('/')[0] === 'Europe'
        this.fetchPackages()
      })
      .catch((err) => {
        console.log(err)
        this.fetchPackages()
      })
  },
  async mounted() {
    await initFacebook()
    window.fbAsyncInit()
    if (this.action === metaEventCustomActions.ON_UNLOCK_BUTTON) {
      this.loadFacebookPixel('BuyIntent')
    } else if (this.action === metaEventCustomActions.ON_QUIZ_FINISHED) {
      this.loadFacebookPixel('InformIntent')
    } else if (this.action === metaEventCustomActions.ON_LOCKED_CLICKED) {
      fbq('trackCustom', 'LockedIntent')
    }
  },
  methods: {
    ...mapActions('packageModule', ['fetchPackage']),
    ...mapActions('checkout', ['fetchCheckoutById']),
    loadFacebookPixel,
    onGetPlan() {
      const isPromo = this.$route.query.checkout === checkoutTypes.PROMO
      let url = `${window.location.pathname}?from=auth`
      if (isPromo) {
        url += `&checkout=${checkoutTypes.PROMO}`
      }
      if (!this.token) {
        this.$router.push({
          name: 'Login',
          query: {
            redirect: url,
          },
        })
      } else this.isOpen = true
    },
    fetchPackages() {
      if (!this.checkoutType) {
        this.fetchPackage({
          place: packagePlaces.AFTER_LOCKED_CONTENT,
          currency: this.isEurope ? currency.EUR : currency.USD,
        })
      }
    },
    getPackageByCondition(condition) {
      let p
      if (this.isEurope) {
        p = this.packages.find(
          (i) => condition(i) && i.currency === currency.EUR
        )
      }
      if (!p)
        p = this.packages.find(
          (i) => condition(i) && i.currency === currency.USD
        )
      return p
    },
    onSuccess() {
      this.isOpen = false
      this.$emit('onSuccess')
    },
    getPackageValue(p) {
      if (p.months === 12) return this.purchaseTypes.YEARLY
      if (p.months === 1) return this.purchaseTypes.MONTHLY
      else return this.purchaseTypes.LIFETIME
    },
  },
}
</script>

<style lang="scss">
.flex {
  display: flex;
}
.skeleton-loader {
  max-width: 327px;
  margin: 0 auto;

  .ant-skeleton-element .ant-skeleton-input {
    height: 100%;
  }

  .ant-skeleton-element .ant-skeleton-button {
    height: 100%;
  }
}
.purchase {
  color: var(--color-white);
  // @media screen and (max-width: 660px) {
  //   padding: 15px 6px !important;
  // }
  &__body {
    margin: 0 auto;
    max-width: 402px;
  }

  &__payment {
    &-title {
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: var(--color-white);
      font-weight: 400;
    }

    &__wrapper {
      margin: 32px 0 24px;
      display: flex;
      justify-content: space-between; //change to space-between when paypal will be active
      & > * + * {
        margin-left: 17px;
      }
    }

    &__btn {
      border: 1px solid rgba(#ffffff, 0.1);
      border-radius: 12px;
      background: inherit;
      height: 72px;
      padding: 0 27px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;

      &:hover {
        opacity: 0.8;
      }

      &.active {
        border: 1px solid #ffffff;
      }

      &-title {
        margin: 8px 0;
        display: block;
        font-size: 16px;
        line-height: 22px;
        color: var(--color-white);
        font-weight: 400;
      }
    }

    &__paypal {
      &--btn {
        font-weight: 400;
        background: var(--color-white);
        border-radius: 58px;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: #134e5e;
        height: 52px;
        width: 100%;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;

        & > svg {
          margin-right: 4px;
          margin-top: 3px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
      &--text {
        font-weight: 400;
        color: var(--color-white);
        text-transform: uppercase;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        margin: 16px 0 24px;
      }

      .ant-spin-container::after {
        border-radius: 58px;
      }
    }
  }

  &__app {
    display: flex;
    justify-content: center;
    align-items: center;

    & > svg {
      &:last-child {
        margin-left: 26px;
      }
    }
  }

  &__rating {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    &-text {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      margin: 8px 0 0;
    }
  }

  &__title {
    font-size: 24px;
    line-height: 33px;
    font-weight: 500;
    color: var(--color-white);
    text-align: center;
    margin: 48px 0 31px;
  }

  &__item {
    font-weight: 500;
    line-height: 19px;
  }

  &__list {
    row-gap: 16px;
  }

  &__total {
    font-weight: 700;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    margin: 36px 0 16px;
  }

  &__cancel {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    margin-bottom: 36px;
  }

  .p-card {
    background: rgba(#ffffff, 0.1);
    border-radius: 12px;
  }

  &__card {
    padding: 16px;
    display: grid;
    align-items: center;
    margin-bottom: 24px;

    &-head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 23px;
    }

    &-number {
      margin-bottom: 16px;
    }

    &-detail {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 17px;
    }

    &-info {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      margin: 24px auto 16px;
      max-width: 198px;
      text-align: center;
    }
  }

  &__input {
    border: 1px solid rgba(#ffffff, 0.1);
    border-radius: 58px;
    height: 52px;
    text-align: center;
    padding: 17px 10px;
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
    width: 100%;
  }

  &__btn {
    min-width: 295px;
    width: 100%;
    margin: 24px auto 8px;

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &__cancel-info {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    margin: 20px 0 48px;
  }

  &__rating-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin: 28px 0 36px;
  }

  &__rating-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;

    & > svg + svg {
      margin-top: 13px;
    }

    &__name {
      font-size: 14px;
      line-height: 19px;
      font-weight: 500;
      margin: 20px 0 8px;

      &--big {
        font-size: 24px;
        line-height: 33px;
      }
    }

    &__label {
      font-size: 14px;
      line-height: 19px;
      font-weight: 500;
      opacity: 0.5;
      margin: 0;
    }

    &--app {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      & > svg:last-child {
        margin-left: 26px;
      }
    }
  }

  &__trial-work {
    padding: 24px 50px 24px 16px;

    &.extra-space {
      padding: 24px 24px 24px 16px;
    }

    &__title {
      font-size: 24px;
      line-height: 33px;
      font-weight: 700;
      margin-bottom: 27px;
      text-align: center;

      &.normal {
        font-weight: 400;
      }
    }

    &__body {
      display: flex;
    }

    &__icons {
      background: linear-gradient(
        180deg,
        rgba(#ffffff, 0.3) 0%,
        rgba(255, 255, 255, 0) 112.9%
      );
      border-radius: 46px 46px 4px 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 9px;
      margin-right: 24px;

      & > svg + svg {
        margin-top: 64px;
      }
    }

    &__items {
      margin-top: 10px;
      display: grid;
      row-gap: 20px;
    }

    &__item {
      &--title {
        font-weight: 700;
        font-size: 16px;
        line-height: 21px;
        margin: 0;
      }

      &--text {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        margin: 4px 0 0;
      }
    }
  }

  &__guarantee {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    align-items: center;
    padding: 20px 24px 24px;
    text-align: center;

    &__title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin: 17px 0 8px;
    }

    &__desc {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      opacity: 0.5;
      margin: 0;
    }

    &__text {
      font-weight: 500;
      margin: 17px 0 0;
      font-size: 14px;
      line-height: 19px;
    }
  }

  &__p {
    text-align: center;
    color: var(--color-white);

    &-m {
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
    }

    &-l {
      font-weight: 500;
      font-size: 48px;
      line-height: 66px;
    }

    &-s {
      font-weight: 700;
      font-size: 18px;
      line-height: 21px;
    }

    &-xs {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
    }
  }

  &__svg-wrapper {
    display: flex;
    justify-content: center;
    margin: 28px 0 12px;
  }

  &__feel-better {
    margin: 5px 0 4px;
  }

  &__wrapper {
    max-width: 402px;
    margin: 0 auto;
  }

  &__comments {
    display: flex;
    margin: 20px 0 48px;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  &__comment {
    border-radius: 12px;
    background: rgba(#ffffff, 0.1);
    padding: 24px;
    width: 264px;
    height: 314px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.middle {
      padding-right: 20px;
    }

    &__text {
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      color: var(--color-white);
    }

    &__author {
      display: flex;

      &-right {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }

      &-name {
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        color: var(--color-white);
      }
    }
  }

  &__note {
    margin: 48px auto;
    max-width: 825px;
  }
}
.package {
  &__item {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(#ffffff, 0.1);
    border-radius: 12px;
    padding: 24px 16px;

    &.popular {
      background: #134e5e;
      padding: 20px 16px;
      border-radius: 12px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      .package__item__price {
        margin-top: 4px;
      }

      .package__item__right.overlay {
        &::before {
          display: none;
        }
      }
    }

    &__checkbox {
      margin-right: 12px;
      width: 16px;
      height: 16px;

      .ant-radio-inner {
        border-color: rgba(#ffffff, 0.5);
      }

      .ant-radio-checked .ant-radio-inner {
        border-color: #ffffff;
      }

      .ant-radio-inner {
        background: transparent;
      }

      .ant-radio-inner::after {
        background: var(--color-white);
      }
    }

    &__title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: var(--color-white);
      margin-bottom: 3px;
      text-transform: uppercase;
    }

    &__sub-title {
      display: block;
      font-size: 12px;
      line-height: 17px;
      text-transform: capitalize;
    }

    &__price {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: rgba(#ffffff, 0.5);
      margin-top: 3px;
    }

    &__price-day {
      font-weight: 700;
      font-size: 48px;
      line-height: 48px;
      color: var(--color-white);
    }

    &__price-old {
      display: flex;
      align-items: flex-end;
      margin-bottom: -8px;
    }

    &__price-per-day {
      font-weight: 700;
      font-size: 32px;
      line-height: 32px;
      color: var(--color-white);
    }

    &__price-p {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: var(--color-white);
    }

    &__price-p-small {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: var(--color-white);
    }

    &__p-wrapper {
      margin-left: 1px;
    }

    &__info {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: rgba(#ffffff, 0.5);
      margin-top: 4px;
    }

    &__right {
      display: flex;
      justify-content: flex-end;
      flex: 1;

      &.overlay {
        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 152px;
          clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 10% 100%, 0% 50%);
          background: rgba(#ffffff, 0.1);
          border-top-right-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }
    }
  }

  &__submit {
    background: var(--color-white);
    border-radius: 58px;
    height: 52px;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: var(--color-main);
    border: none;
    width: 100%;
    transition: background 300ms ease-in-out;
    margin-bottom: 24px;

    &:hover {
      background: rgba(#fff, 0.8);
    }
  }

  &__popular {
    &__head {
      background: var(--color-white);
      border-radius: 12px 12px 0px 0px;
    }

    &__title {
      font-weight: 400;
      font-size: 12px;
      line-height: 21px;
      color: #134e5e;
      text-align: center;
      padding: 4px 0 3px;
    }
  }

  &__card {
    cursor: pointer;
    border-radius: 12px;
    border: 1px solid transparent;
    min-width: 327px;

    &:hover {
      border: 1px solid rgba(#ffffff, 0.3);
    }
  }
}

.payments {
  .ant-modal {
    max-width: 887px;
  }

  .ant-modal-content {
    background: #134e5e;
    border-radius: 12px;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;
  }

  &__close {
    position: absolute;
    top: 17px;
    right: 17px;
    background: inherit;
    border: none;
    cursor: pointer;
  }
}

.strikethrough {
  text-decoration: line-through;
  color: rgba(#ffffff, 0.5);
}

.mb-48 {
  margin-bottom: 48px;
}
</style>
